import api from './api';
import type { AskQuota, RAGCitation } from './api';

export type WisemanAgentId = 'sasha' | 'pickle_rick' | 'gonzo';

export interface WisemanAgentSummary {
  id: WisemanAgentId;
  display_name: string;
  short_name: string;
  epithet: string;
}

export interface WisemenTurn {
  id: number;
  role: 'user' | 'assistant';
  agent_id?: WisemanAgentId | null;
  content: string;
  citations: RAGCitation[];
  created_at: string;
}

export interface WisemenConversationSummary {
  id: string;
  title?: string | null;
  created_at: string;
  updated_at?: string | null;
  turn_count: number;
}

export interface WisemenConversationDetail {
  id: string;
  title?: string | null;
  created_at: string;
  updated_at?: string | null;
  turns: WisemenTurn[];
}

export interface WisemenChatResponse {
  conversation_id: string;
  agent: WisemanAgentSummary;
  turn: WisemenTurn;
  quota?: AskQuota;
}

export const wisemenAPI = {
  newConversation: (): Promise<{ conversation_id: string; created_at: string }> =>
    api.post('/wisemen/conversation/new').then((res) => res.data),

  listConversations: (): Promise<WisemenConversationSummary[]> =>
    api.get('/wisemen/conversations').then((res) => res.data),

  getConversation: (conversationId: string): Promise<WisemenConversationDetail> =>
    api.get(`/wisemen/conversation/${conversationId}`).then((res) => res.data),

  chat: (
    conversationId: string,
    message: string,
    agentId?: WisemanAgentId
  ): Promise<WisemenChatResponse> =>
    api
      .post(
        '/wisemen/chat',
        {
          conversation_id: conversationId,
          message,
          agent_id: agentId ?? null,
        },
        { timeout: 90000 }
      )
      .then((res) => res.data),
};
